import { Link } from "react-router-dom";

type SenderEmailWarningProps = {
  className?: string;
};

/**
 * 送信者メールアドレス未登録時の警告コンポーネント
 * @param {object} props - コンポーネントProps
 * @param {string} [props.className] - 追加のCSSクラス
 * @return {JSX.Element} 警告ボックス
 */
export function SenderEmailWarning({
  className = "",
}: SenderEmailWarningProps) {
  return (
    <div
      className={`bg-yellow-50 border border-yellow-200 rounded-lg p-3 text-sm text-yellow-800 ${className}`}
    >
      <p className="font-semibold mb-1">
        送信元メールアドレスが登録されていません
      </p>
      <p>メールを送信するには、先に送信者メールアドレスを登録してください。</p>
      <Link
        to="/settings/sender-emails"
        className="btn btn-warning btn-xs mt-2"
      >
        配信者管理へ
      </Link>
    </div>
  );
}
